import * as yup from "yup";
import {
  apiSecretSchema,
  apiKeySchema,
  identifierSchema,
  usernameSchema,
  passwordSchema,
  platformSchema,
  confirmPasswordSchema,
  portSchema,
  noteSchema,
  fileSchema,
  connectionStringsSchema,
  otherSchema,
  memberArraySchema1,
  expiryDate,
  memberArraySchema2,
  pwExpiryDate,
} from "./ValidationSchemas";

export const apisSchema = yup.object({
  identifier: identifierSchema,
  platform: platformSchema,
  apiKey: apiKeySchema,
  apiSecret: apiSecretSchema,
  // keyfile: fileSchema,
  pwExpiryDate: pwExpiryDate,
  note: noteSchema,
});
export const databaseSchema = yup.object({
  identifier: identifierSchema,
  platform: platformSchema,
  username: usernameSchema,
  port: portSchema,
  dbconnectionStrings: connectionStringsSchema,
  password: passwordSchema,
  confirmPassword: confirmPasswordSchema,
  pwExpiryDate: pwExpiryDate,
  note: noteSchema,
});
export const webSchema = yup.object({
  identifier: identifierSchema,
  platform: platformSchema,
  username: usernameSchema,
  password: passwordSchema,
  confirmPassword: confirmPasswordSchema,
  pwExpiryDate: pwExpiryDate,
  note: noteSchema,
});
export const serverSchema = yup.object({
  identifier: identifierSchema,
  platform: platformSchema,
  username: usernameSchema,
  port: portSchema,
  password: passwordSchema,
  confirmPassword: confirmPasswordSchema,
  pwExpiryDate: pwExpiryDate,
  note: noteSchema,
});
export const cloudSchema = yup.object({
  identifier: identifierSchema,
  platform: platformSchema,
  username: usernameSchema,
  password: passwordSchema,
  confirmPassword: confirmPasswordSchema,
  // keyfile: fileSchema,
  pwExpiryDate: pwExpiryDate,
  note: noteSchema,
});
export const apisSchemaEdit = yup.object({
  identifier: identifierSchema,
  platform: platformSchema,
  apiKey: apiKeySchema,
  // keyfile: fileSchema,
  pwExpiryDate: pwExpiryDate,
  note: noteSchema,
});
export const databaseSchemaEdit = yup.object({
  identifier: identifierSchema,
  platform: platformSchema,
  username: usernameSchema,
  port: portSchema,
  dbconnectionStrings: connectionStringsSchema,
  confirmPassword: confirmPasswordSchema,
  pwExpiryDate: pwExpiryDate,
  note: noteSchema,
});
export const webSchemaEdit = yup.object({
  identifier: identifierSchema,
  platform: platformSchema,
  username: usernameSchema,
  confirmPassword: confirmPasswordSchema,
  pwExpiryDate: pwExpiryDate,
  note: noteSchema,
});
export const serverSchemaEdit = yup.object({
  identifier: identifierSchema,
  platform: platformSchema,
  username: usernameSchema,
  port: portSchema,
  confirmPassword: confirmPasswordSchema,
  pwExpiryDate: pwExpiryDate,
  note: noteSchema,
});
export const cloudSchemaEdit = yup.object({
  identifier: identifierSchema,
  platform: platformSchema,
  username: usernameSchema,
  confirmPassword: confirmPasswordSchema,
  // keyfile: fileSchema,
  pwExpiryDate: pwExpiryDate,
  note: noteSchema,
});
export const otherSchemaObj = yup.object({
  identifier: identifierSchema,
  other: otherSchema,
  pwExpiryDate: pwExpiryDate,
  note: noteSchema,
});

export const sharePWSchemaObj = yup.object({
  shareWith: memberArraySchema2,
  expiryDate: expiryDate,
  note: noteSchema,
});
